import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
  constructor(private router: Router, private meta: Meta) {
    let darkMode = localStorage.getItem("darkMode") === "true";

    if (darkMode) {
      document.documentElement.classList.add("dark");
      this.meta.updateTag({ content: '#1F2937' }, 'name=theme-color');
    } else {
      this.meta.updateTag({ content: '#F9FAFB' }, 'name=theme-color');

    }
  }

  ngOnInit() {

  }
}
